module.exports = __webpack_public_path__ + "022e578efca9b2c340fc4f8552e8fb70.png";